import http from '../services/http';
import { typeAs } from '../services/utils';
import Str from '../services/str';

export default {
  namespaced: true,

  state: {
    financials: [],
    financial: null,
    links: null,
    meta: null,
    filter: {
      tab: '',
      year: '',
      keyword: '',
      status: '',
    },
  },

  mutations: {
    CLEAR_ALL(state) {
      state.financials = [];
      state.financial = null;
    },
    SET_FINANCIALS(state, data) {
      state.financials = data.data.map(
        (item) => {
          item.isChecked = false;
          return item;
        },
      );
      state.links = data.links;
      state.meta = data.meta;
    },
    SET_FINANCIAL(state, data) {
      state.financial = data;
    },
    SET_FILTER(state, data) {
      state.filter = data;
    },
    SET_META(state, data) {
      state.meta = data;
    },
  },

  actions: {
    clear({ commit }) {
      commit('CLEAR_ALL');
    },

    setFilter({ commit }, data) {
      commit('SET_FILTER', data);
    },

    setMeta({ commit }, data) {
      commit('SET_META', data);
    },

    setFinancial({ commit }, data) {
      commit('SET_FINANCIAL', data);
    },

    find({ commit, state }) {
      let url = `/financials?${Str.query(state.filter)}`;
      if (state.meta) {
        url += `&page=${state.meta.current_page}&page_count=${state.meta.per_page}`;
      }
      return http(url)
        .then((response) => {
          response.body.data.map(typeAs('IR'));
          return response.body;
        })
        .then((response) => {
          commit('SET_FINANCIALS', response);
        });
    },

    findById({ commit }, id) {
      return http(`/financials/${id}`)
        .then((response) => response.body)
        .then(typeAs('IR'))
        .then((item) => {
          commit('SET_FINANCIAL', item);
        });
    },

    destroy(_, id) {
      return http(`/financials/${id}`, { method: 'DELETE' })
        .then((response) => response.body);
    },

    save(_, {
      id, ...data
    }) {
      const request = id
        ? http(`/financials/${id}`, { method: 'PUT', data })
        : http('/financials', { method: 'POST', data });

      return request.then((response) => response.body);
    },
  },
};
